export const Status = {
  '1': 'Активен',
  '11': 'Заблокирован',
  '21': 'В архиве',
} as const;

export const Roles = {
  ROLE_ADMIN: 'Администратор',
  ROLE_OPERATOR: 'Оператор',
} as const;

export enum TypeModalWindow {
  ORGANIZATION_DIALOG = 1,
  SUBDIVISION_DIALOG = 2,
  CONFIG_DIALOG = 3,
  THANKS_DIALOG = 4,
  ACCESS_DIALOG = 5,
}

export const SUBDIVISION_HEAD_ID = 6;

export const statusSelectData = Object.entries(Status);
export const roleSelectData = Object.entries(Roles);
export type RolesKeys = keyof typeof Roles;
export type StatusKeys = keyof typeof Status;
